module.exports = __webpack_public_path__ + "img/smzq5.2ffb094b.png";